// export const isTestPaused;
import moment from 'moment';
export const isFixedTest  = schedule => schedule === 'fixed'
export const isAnyTimeTest = schedule => schedule === 'anytime'
export const isTimePeriodTest = schedule => schedule === 'timePeriod'
export const _isUserAttempted = userStatus => userStatus === 'attempted'
export const _isUserUnAttempted = userStatus => userStatus === 'unattempted'
export const _isUserSubmitted = userStatus => userStatus === 'submitted'
export const isTestInAnHour = startTime => ((moment(startTime) - moment()) / 1000 < 86400)
export const isTimeEndForTestStart = startTime => ((moment(startTime) - moment()) / 1000 < 0)
export const isTestSeriesFree = price =>  price < 1
export const isTestSeriesTestFree = isFree => isFree
export const isTestSeriesUserPaid = paymentId => paymentId
export const isPercentageArrayLengthZero = percentage => percentage && percentage.length === 0 